import React, { useEffect } from 'react';
import { APP_NAME } from '../../constants';
import { getCgvDocument } from '../../data/cgvContent';

const CgvDocument = () => {
  const doc = getCgvDocument(APP_NAME);

  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash.replace('#', '');
      if (!hash) return;
      requestAnimationFrame(() => {
        document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    };

    scrollToHash();
    window.addEventListener('hashchange', scrollToHash);
    return () => window.removeEventListener('hashchange', scrollToHash);
  }, []);

  return (
    <article className="marketing-muted">
      <p className="marketing-accent text-sm mb-6">{doc.lastUpdatedLabel}</p>
      <p className="text-base leading-relaxed mb-8">{doc.intro}</p>

      <nav aria-label="Sommaire des CGV" className="glass-panel mb-10 rounded-2xl p-5">
        <p className="text-white font-semibold mb-3">Sommaire</p>
        <ol className="space-y-2 text-sm">
          {doc.sections.map((section) => (
            <li key={section.id}>
              <a href={`#${section.id}`} className="marketing-link">
                {section.number}. {section.title}
              </a>
            </li>
          ))}
        </ol>
      </nav>

      {doc.sections.map((section) => (
        <section key={section.id} id={section.id} className="mb-10 scroll-mt-24">
          <h2 className="text-xl font-semibold text-white mb-4">
            {section.number}. {section.title}
          </h2>
          {section.paragraphs.map((paragraph, index) => (
            <p key={index} className="text-sm leading-relaxed mb-3">
              {paragraph}
            </p>
          ))}
          {section.table ? (
            <div className="overflow-x-auto mt-4 rounded-2xl border border-cyan-300/20">
              <table className="w-full text-sm text-left min-w-[280px]">
                <caption className="sr-only">{section.table.caption}</caption>
                <thead className="bg-cyan-400/10">
                  <tr>
                    {section.table.headers.map((header) => (
                      <th key={header} scope="col" className="px-4 py-3 font-semibold text-white">
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {section.table.rows.map((row) => (
                    <tr key={row[0]} className="border-t border-cyan-300/10 bg-slate-950/20">
                      {row.map((cell, cellIndex) => (
                        <td key={`${row[0]}-${cellIndex}`} className="px-4 py-3 whitespace-nowrap">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : null}
        </section>
      ))}
    </article>
  );
};

export default CgvDocument;
